import React, { FC, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { usePostponeSurveyMutation } from 'src/modules/shared/slices/survey/surveyApi';
import { StyledButtonLink } from '../../../components/styled';

const PostPoneConfirmationDialog: FC<{ onClose: VoidFunction; onSubmit: VoidFunction }> = ({
  onClose,
  onSubmit,
}) => {
  const [, { isLoading: dismissLoading, isSuccess: dismissSuccess }] = usePostponeSurveyMutation({
    fixedCacheKey: 'postpone-confirmation-dialog',
  });

  useEffect(() => {
    if (dismissSuccess) {
      onClose();
    }
  }, [dismissSuccess, onClose]);

  return (
    <>
      <Dialog onClose={() => onClose()} open={true} maxWidth="xs">
        <DialogContent style={{ marginBottom: '8px' }}>
          Je hebt al informatie ingevuld. Die gaat verloren als je uitstelt tot morgen.
        </DialogContent>
        <DialogActions>
          <StyledButtonLink variant="text" onClick={() => onSubmit()} disabled={dismissLoading}>
            toch uitstellen
          </StyledButtonLink>
          <Button
            onClick={() => onClose()}
            variant="contained"
            color="primary"
            disableElevation
            style={{ textTransform: 'none' }}
            disabled={dismissLoading}
          >
            terug
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PostPoneConfirmationDialog;
